import { DrawerDiaLog } from '../drawer-dialog';
import { OnboardContent } from './onboard-content';

type UserSignInProps = {
  className?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
};
export const OnboardModel = ({ open, setOpen }: UserSignInProps) => {
  return (
    <DrawerDiaLog
      open={open}
      setOpen={setOpen}
      className="bg-card px-4 pb-4 md:p-4 md:p-2 w-full max-w-[920px] md:max-h-[620px] overflow-hidden"
    >
      <OnboardContent onClose={() => setOpen?.(false)} />
    </DrawerDiaLog>
  );
};
